/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Accordion from 'shared/ui/components/Accordion.vue';
import AttendanceTrackingSettings from '../AttendanceTrackingSettings.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import LegalPicker from 'shared/ui/components/form-components/pickers/LegalPicker.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import StringsArrayInput from 'shared/ui/components/form-components/StringsArrayInput.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import AnonymizeAllOrByDomain from '../AnonymizeAllOrByDomain.vue';

// Mixins
import baseWorkspaceSettings from 'ui/mixins/workspaces/base-settings';

// Utils
import { get } from 'lodash';

// Constants
import { ATTENDANCE_TRACKING_DEFAULTS } from 'libs/utils/constants';

const __vue_script__ = {
    name: 'WorkspaceDefaultSettingsForm',

    components: { BaseInput, BaseSelect, LegalPicker, RadioButtons, StringsArrayInput, Toggler, Accordion, AttendanceTrackingSettings, AnonymizeAllOrByDomain },

    mixins: [baseWorkspaceSettings],

    props: {
        organization: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            attendanceTracking: null,
            canChangeWorkspaceDuration: this.$services.user.hasPermission(
                'org_realms.change_workspace_duration'
            ),
            internalOrganization: {},
            forceAnonymizationOptions: [
                {
                    hint: this.$i18n.t('organization.workspaces.form.force_anonymization_off_hint'),
                    label: this.$i18n.t('organization.workspaces.form.force_anonymization_off'),
                    newLineHint: true,
                    value: 'false',
                },
                {
                    hint: this.$i18n.t('organization.workspaces.form.force_anonymization_on_hint'),
                    label: this.$i18n.t('organization.workspaces.form.force_anonymization_on'),
                    newLineHint: true,
                    value: 'true',
                }
            ],
        };
    },

    computed: {
        enabledAnonymization() {
            return this.organization.enable_anonymization;
        }
    },

    created() {
        // Existing (old) organizations don't have this property yet
        this.form.enable_google_calendar = get(this.organization, 'workspace_defaults.enable_google_calendar', false);
        this.form.show_activation_codes = get(this.organization, 'workspace_defaults.show_activation_codes', true);
        this.form.show_access_as = get(this.organization, 'workspace_defaults.show_access_as', true);
        this.form.force_anonymization = get(this.organization, 'workspace_defaults.force_anonymization', false).toString();
        this.internalOrganization = this.organization;
        this.attendanceTracking = get(this.organization, 'workspace_defaults.attendance_tracking', ATTENDANCE_TRACKING_DEFAULTS);
    },

    methods: {
        /**
         * Transforms the form into updatable parameters.
         *
         * @returns {Object} the organization's updates parameters
         */
        formToUpdateParams() {
            return {
                timezone: this.form.timezone,
                servers_location: get(this.form, 'servers_location.value'),
                privacy_documents: this.form.privacy_documents.map(d => d._id),
                container_app: (this.form.container_app || {}).fp_ext_id,
                show_cookie_banner: this.form.show_cookie_banner,
                show_activation_codes: this.form.show_activation_codes,
                unrestricted_workspace_duration: this.form.unrestricted_workspace_duration,
                show_access_as: this.form.show_access_as,
                force_anonymization: this.form.force_anonymization === 'true',
                enable_category: Boolean(this.form.enable_category),
                enable_google_calendar: this.form.enable_google_calendar,
                category_label: this.form.category_label,
                category_values: this.form.category_values,
                category_multiselect: Boolean(this.form.category_multiselect),
                attendance_tracking: this.attendanceTracking,
                anonymization_domains: this.form.force_anonymization === 'true' ? this.form.anonymization_domains : undefined,
            };
        },

        /**
         * Tries to persist collected data into the organization.
         */
        async save() {
            try {
                const defaults = this.formToUpdateParams();

                // Store the data
                await this.$services.org.saveWorkspaceDefaults(this.organization.name, defaults);

                this.$notify({
                    group: 'flashes',
                    text: this.t('update_success').toString(),
                    type: 'success',
                });

                // Update current organization info
                this.internalOrganization.workspace_defaults = defaults;

            } catch (error) {
                this.$notify({
                    group: 'flashes',
                    text: error.message,
                    type: 'error'
                });
            }
        },

        /**
         * Utility method to make the template more readable
         *
         * @param {String} key the key to translate
         *
         * @return {String} the translated message
         */
        t(key) {
            return this.$i18n.t(`organization.workspaces.form.${key}`).toString();
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"org-default-settings",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('fieldset',[_c('base-select',{ref:"timezone",attrs:{"label":_vm.t('timezone'),"placeholder":_vm.t('timezone_placeholder'),"name":"timezone","options":_vm.timezones,"options-label":null},model:{value:(_vm.form.timezone),callback:function ($$v) {_vm.$set(_vm.form, "timezone", $$v)},expression:"form.timezone"}}),_c('base-select',{ref:"servers_location",attrs:{"label":_vm.t('servers_location'),"placeholder":_vm.t('servers_location_placeholder'),"name":"servers_location","options":_vm.servers_locations,"track-by":"value"},model:{value:(_vm.form.servers_location),callback:function ($$v) {_vm.$set(_vm.form, "servers_location", $$v)},expression:"form.servers_location"}}),_c('legal-picker',{ref:"privacy_documents",attrs:{"org-name":_vm.organization.name,"label":_vm.t('privacy_documents'),"placeholder":_vm.t('privacy_documents_placeholder'),"name":"privacy_documents","track-by":"_id"},model:{value:(_vm.form.privacy_documents),callback:function ($$v) {_vm.$set(_vm.form, "privacy_documents", $$v)},expression:"form.privacy_documents"}}),_c('toggler',{ref:"show_cookie_banner",attrs:{"label":_vm.t('cookie_banner'),"name":"show_cookie_banner","on-label":"general.enabled","off-label":"general.disabled"},model:{value:(_vm.form.show_cookie_banner),callback:function ($$v) {_vm.$set(_vm.form, "show_cookie_banner", $$v)},expression:"form.show_cookie_banner"}}),_c('base-select',{ref:"container_app",attrs:{"label":_vm.t('container_app'),"placeholder":_vm.t('container_app_placeholder'),"name":"container_app","options":_vm.container_apps,"track-by":"_id","hint":_vm.t('container_app_hint')},model:{value:(_vm.form.container_app),callback:function ($$v) {_vm.$set(_vm.form, "container_app", $$v)},expression:"form.container_app"}}),(_vm.enabledAnonymization)?_c('radio-buttons',{ref:"force_anonymization",attrs:{"label":_vm.$t('organization.workspaces.form.force_anonymization'),"hint":_vm.$t('organization.workspaces.form.force_anonymization_hint'),"name":"force_anonymization","options":_vm.forceAnonymizationOptions},model:{value:(_vm.form.force_anonymization),callback:function ($$v) {_vm.$set(_vm.form, "force_anonymization", $$v)},expression:"form.force_anonymization"}}):_vm._e(),(_vm.form.force_anonymization==='true')?_c('anonymize-all-or-by-domain',{model:{value:(_vm.form.anonymization_domains),callback:function ($$v) {_vm.$set(_vm.form, "anonymization_domains", $$v)},expression:"form.anonymization_domains"}}):_vm._e(),_c('toggler',{ref:"show_activation_codes",attrs:{"label":_vm.t('activation_codes'),"hint":_vm.t('activation_codes_hint'),"name":"show_activation_codes","on-label":"general.enabled","off-label":"general.disabled"},model:{value:(_vm.form.show_activation_codes),callback:function ($$v) {_vm.$set(_vm.form, "show_activation_codes", $$v)},expression:"form.show_activation_codes"}}),_c('toggler',{ref:"show_access_as",attrs:{"label":_vm.t('show_access_as'),"hint":_vm.t('show_access_as_hint'),"name":"show_access_as","on-label":"general.enabled","off-label":"general.disabled"},model:{value:(_vm.form.show_access_as),callback:function ($$v) {_vm.$set(_vm.form, "show_access_as", $$v)},expression:"form.show_access_as"}}),_c('toggler',{ref:"enable_google_calendar",attrs:{"label":_vm.t('enable_google_calendar'),"name":"enable_google_calendar","on-label":"general.enabled","off-label":"general.disabled"},model:{value:(_vm.form.enable_google_calendar),callback:function ($$v) {_vm.$set(_vm.form, "enable_google_calendar", $$v)},expression:"form.enable_google_calendar"}}),(_vm.canChangeWorkspaceDuration)?_c('toggler',{ref:"unrestricted_workspace_duration",attrs:{"label":_vm.t('unrestricted_workspace_duration'),"name":"unrestricted_workspace_duration","on-label":"general.enabled","off-label":"general.disabled"},model:{value:(_vm.form.unrestricted_workspace_duration),callback:function ($$v) {_vm.$set(_vm.form, "unrestricted_workspace_duration", $$v)},expression:"form.unrestricted_workspace_duration"}}):_vm._e(),_c('toggler',{ref:"enable_category",attrs:{"label":_vm.t('enable_category'),"name":"enable_category","on-label":"general.enabled","off-label":"general.disabled"},model:{value:(_vm.form.enable_category),callback:function ($$v) {_vm.$set(_vm.form, "enable_category", $$v)},expression:"form.enable_category"}}),(_vm.form.enable_category)?_c('div',{staticClass:"feature-dependant"},[_c('base-input',{attrs:{"name":"category_label","label":_vm.t('category_label')},model:{value:(_vm.form.category_label),callback:function ($$v) {_vm.$set(_vm.form, "category_label", $$v)},expression:"form.category_label"}}),_c('strings-array-input',{attrs:{"label":_vm.t('category_values'),"name":"category_values","emit-empty":true,"placeholder":_vm.t('category_values_placeholder')},model:{value:(_vm.form.category_values),callback:function ($$v) {_vm.$set(_vm.form, "category_values", $$v)},expression:"form.category_values"}}),_c('toggler',{ref:"category_multiselect",attrs:{"label":_vm.t('category_multiselect'),"name":"category_multiselect","on-label":"general.enabled","off-label":"general.disabled"},model:{value:(_vm.form.category_multiselect),callback:function ($$v) {_vm.$set(_vm.form, "category_multiselect", $$v)},expression:"form.category_multiselect"}})],1):_vm._e()],1),_c('fieldset',[(_vm.attendanceTracking)?_c('accordion',{attrs:{"headers-i18n-prefix":"general_settings.menu.attendance_criteria_accordeon","unlimited-height":true}},[_c('attendance-tracking-settings',{attrs:{"attendance-tracking":_vm.attendanceTracking}})],1):_vm._e()],1),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary"},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WorkspaceDefaultSettingsForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__